﻿export * from './auth/login/login.component';
export * from './auth/register/register.component';
export * from './home/home.component';
export * from './page.management/pages/pages.component';
export * from './page.management/pages.edit/pages.edit.component';
export * from './page.management/poolspaguides/poolspaguides.component';
export * from './page.management/poolcatalogues/poolcatalogues.component';
export * from './page.management/microsites/microsites.component';
export * from './page.management/assistance/assistance.component';
export * from './page.management/snippets/snippets.component';
export * from './page.management/snippet.edit/snippet.edit.component';
export * from './page.management/pagecategories/pagecategories.component';
export * from './page.management/pagecategories.edit/pagecategories.edit.component';
export * from './pool.management/pools/pools.component';
export * from './pool.management/pools.edit/pools.edit.component';
export * from './pool.management/media/pool-media.component';
export * from './pool.management/media.edit/pool-media.edit.component';
export * from './product.management/categories/categories.component';
export * from './product.management/categories.edit/categories.edit.component';
export * from './product.management/products/products.component';
export * from './product.management/products.edit/products.edit.component';
export * from './product.management/features/features.component';
export * from './product.management/features.edit/features.edit.component';
export * from './product.management/resources/resources.component';
export * from './product.management/resources.edit/resources.edit.component';
export * from './product.management/custom-attributes/custom-attributes.component';
export * from './product.management/custom-attributes.edit/custom-attributes.edit.component';
export * from './product.management/specifications/specifications.component';
export * from './product.management/specifications.edit/specifications.edit.component';
export * from './product.management/images/product-images.component';
export * from './product.management/images.edit/product-images.edit.component';
export * from './product.management/sku/sku.component';
export * from './product.management/sku.edit/sku.edit.component';
export * from './user.management/roles/roles.component';
export * from './user.management/roles.edit/roles.edit.component';
export * from './user.management/users/users.component';
export * from './user.management/users.edit/users.edit.component';
export * from './user.management/password.edit/password.edit.component';
export * from './faq.management/faq/faq.component';
export * from './faq.management/faq.edit/faq.edit.component';

export * from './faq.management/faqcategories/faqcategories.component';
export * from './faq.management/faqcategories.edit/faqcategories.edit.component';


export * from './password.update/password.update.component';
export * from './warranty.management/warranty/warranty.component';
export * from './warranty.management/warranty.edit/warranty.edit.component';
export * from './warranty.management/assistant/assistant.component';
export * from './bookservice.management/bookservice/bookservice.component';
export * from './bookservice.management/bookservice.edit/bookservice.edit.component';
export * from './contactservice.management/contactservice/contactservice.component';
export * from './contactservice.management/contactservice.edit/contactservice.edit.component';
export * from './promotion.management/banner/banner.component';
export * from './promotion.management/banner.edit/banner.edit.component';
export * from './bookgroup.management/bookgroup/bookgroup.component';
export * from './bookgroup.management/bookgroup.edit/bookgroup.edit.component';
export * from './promotion.management/tag/tag.component';
export * from './promotion.management/tag.edit/tag.edit.component';
export * from './warranty.management/info/info.component';
export * from './warranty.management/info.edit/info.edit.component';
export * from './warranty.management/faq/faq.component';
export * from './warranty.management/faq.edit/faq.edit.component';
export * from './warranty.management/help/help.component';
export * from './warranty.management/help.edit/help.edit.component';
export * from './warranty.management/how/how.component';
export * from './warranty.management/how.edit/how.edit.component';
export * from './warranty.management/why/why.component';
export * from './warranty.management/why.edit/why.edit.component';

// sections
export * from './page.management/sections/section.component';
export * from './page.management/sections/section.items/slider/slider.item.component';
export * from './page.management/sections/section.items/ten_step/ten_step.item.component';
export * from './page.management/sections/section.items/accordion/accordion.item.component';
export * from './page.management/sections/section.items/questionaire/questionaire.item.component';
export * from './page.management/sections/section.items/contactinfo/contactinfo.item.component';
export * from './page.management/sections/section.items/bannerproducts/bannerproducts.item.component';
export * from './page.management/sections/section.items/recallsteps/recallsteps.item.component';
export * from './page.management/sections/section.items/recallfaqs/recallfaqs.item.component';
export * from './page.management/sections/section.items/recallproductslist/recallproductslist.item.component';
export * from './page.management/sections/section.items/recallproductsdropdown/recallproductsdropdown.item.component';
export * from './page.management/sections/section.items/recallform/recallform.item.component';

// reports
export * from './report.management/builder-contact-request/builder-contact-request.component';

export * from './dealer.management/dealer/dealer.component';
export * from './dealer.management/dealer.edit/dealer.edit.component';
export * from './dealer.management/dealer-lead-enquiries/dealer-lead-enquiries.component';

//Main Promotions
export * from './promotions.management/promotion/promotion.component';
export * from './promotions.management/promotion.edit/promotion.edit.component';

//Customers
export * from './customer.management/customer/customer.component';
export * from './customer.management/customer.edit/customer.edit.component';

//warranty
export * from './exportImport.management/products/products-export.component';

// robotic table
export * from './page.management/sections/section.items/robotictable/robotictable.item.component';

// table
export * from './page.management/sections/section.items/table/table.item.component';
export * from './page.management/sections/section.items/table/inline-edit/inline-edit.component';
//publish drafts
export * from './product.management/publishdialog/publish-dialog.component';

// footer links
export * from './page.management/footerlinks/footerlinks.component';
export * from './page.management/footerlinks.edit/footerlinks.edit.component';

// footer socials
export * from './page.management/footersocials/footersocials.component';
export * from './page.management/footersocials.edit/footersocials.edit.component';